export const CURRENT_YEAR = new Date().getFullYear();

export const APP_BASE_PATH = '/docs';

export const STATIC_PAGES = ['/search'];

export const STATIC_PAGE_PLATFORM_NAMES = {
  'ML Space': 'ml-space',
  'Облако VMware': 'vmware',
  Advanced: 'advanced',
  Evolution: 'evolution',
} as const;

export const PLATFORMS = {
  evolution: 'Evolution',
  advanced: 'Advanced',
  mlSpace: 'ML Space',
  vmware: 'Облако VMware',
} as const;

export const KEY_CODES = {
  arrowLeft: 'ArrowLeft',
  arrowRight: 'ArrowRight',
  slash: '/',
  switchTheme: 'Alt+Shift+KeyT',
};

export const LS_KEYS = {
  platform: 'refPlatform',
};

export const SEO_CONFIG = {
  baseTitle: 'Документация Cloud.ru — документация Cloud ',
  description: 'Документация Cloud.ru. Изучите руководство и инструкцию в разделе: Cloud.',
};

export const HERO_SECTION_SEARCH_INPUT_ID = 'hero-section-search-input';

export const H_TAG_NAMES = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

export const TOC_UPDATE_DELAY_MS = 2000;

export const CDN_ROOT_IMAGES_PATH = '/_images';

export const CLOSE_FEEDBACK_FORM_DELAY_MS = 3000;
